import { motion } from 'framer-motion';
import { forwardRef } from 'react';
import { classes } from '../../../utils/commonUtils';
import styles from './progress-bar.module.scss';

interface ProgressBarProps {
  value: number;
  label?: string;
  className?: string;
}

export const ProgressBar = forwardRef<HTMLDivElement, ProgressBarProps>(
  ({ value, label = 'Watched', className }, ref) => {
    if (value < 1) {
      return null;
    }

    return (
      <motion.div
        ref={ref}
        initial={{
          opacity: 0,
          y: 10,
        }}
        animate={{
          opacity: 1,
          y: 0,
        }}
        exit={{
          opacity: 0,
          y: 10,
        }}
        className={classes(styles.container, className)}
      >
        <progress className={styles.progress} aria-label={label} value={value} max={100} />
        <div style={{ width: `${value}%` }} className={styles.bar} />
      </motion.div>
    );
  },
);
